import { render, staticRenderFns } from "./CdbCustomerEdit.vue?vue&type=template&id=b834497e&scoped=true&"
import script from "./CdbCustomerEdit.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerEdit.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerEdit.vue?vue&type=style&index=0&id=b834497e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b834497e",
  null
  
)

export default component.exports